import { render, staticRenderFns } from "./LocateLead.vue?vue&type=template&id=c98a660a&scoped=true&"
import script from "./LocateLead.vue?vue&type=script&lang=ts&"
export * from "./LocateLead.vue?vue&type=script&lang=ts&"
import style0 from "./LocateLead.vue?vue&type=style&index=0&id=c98a660a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98a660a",
  null
  
)

export default component.exports